import script from "./CartModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CartModal.vue?vue&type=script&setup=true&lang=js"

import "./CartModal.vue?vue&type=style&index=0&id=dc27f16a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc27f16a"]])

export default __exports__